// src/pages/SupplierForm.jsx

import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from '../../axios';
import { 
  Container, Paper, Typography, Grid, TextField, Button, Box, Switch, 
  FormControlLabel, CircularProgress, Dialog, DialogContent 
} from "@mui/material";
import { LocalShipping as LocalShippingIcon } from "@mui/icons-material";

export default function SupplierForm({ onSuccess, onCancel, isModal = false }) {
  const navigate = useNavigate();
  const { id } = useParams();
  const editingId = !isModal && id ? parseInt(id, 10) : null;

  const companyId = parseInt(localStorage.getItem('companyId'), 10) || 0;
  const branchId = parseInt(localStorage.getItem('branchId'), 10) || 0;

  const [form, setForm] = useState({
    name: '', taxNumber: '', mobile: '', address: '', country: '', 
    city: '', phone: '', email: '', notes: '', isActive: true
  });
  
  const [loading, setLoading] = useState(false);
  const [successModal, setSuccessModal] = useState(false); // الحالة المسؤولة عن إظهار الرسالة

  useEffect(() => {
    if (!editingId) return;
    axios.get(`/Supplier/${editingId}`)
      .then(res => setForm(res.data))
      .catch(() => alert('❌ فشل في تحميل بيانات المورد'));
  }, [editingId]);

  const handleChange = e => {
    const { name, value, type, checked } = e.target;
    setForm(f => ({ ...f, [name]: type === 'checkbox' ? checked : value }));
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    const payload = { ...form, companyId, branchId };

    try {
      const response = editingId
        ? await axios.put(`/Supplier/${editingId}`, payload)
        : await axios.post('/Supplier', payload);
      
      // ✅ إظهار الرسالة العصرية بدلاً من alert
      setSuccessModal(true);
      setTimeout(() => {
        setSuccessModal(false);
        if (onSuccess) onSuccess({ ...form, id: response.data?.id || response.data?.Id, ...response.data });
        else navigate('/Supplier');
      }, 2000);
      
    } catch (err) {
      alert(err.response?.data?.title || '❌ حدث خطأ أثناء الحفظ');
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => (onCancel ? onCancel() : navigate('/Supplier'));

  return (
    <Container maxWidth="md" disableGutters={isModal} sx={{ my: isModal ? 0 : 3 }} dir="rtl">
      <Paper elevation={0} sx={{ p: 4, borderRadius: '24px', border: '1px solid #e2e8f0' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 4 }}>
          <LocalShippingIcon sx={{ fontSize: 40, color: '#1e40af' }} />
          <Typography variant="h4" fontWeight="800">
            {editingId ? 'تعديل بيانات المورد' : 'إضافة مورد جديد'}
          </Typography>
        </Box>

        <form onSubmit={handleSubmit} className="space-y-6">
          {/* حقول الإدخال */}
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <TextField fullWidth label="اسم المورد" name="name" value={form.name} onChange={handleChange} required sx={{ '& .MuiOutlinedInput-root': { borderRadius: '16px' } }} />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField fullWidth label="الرقم الضريبي" name="taxNumber" value={form.taxNumber} onChange={handleChange} sx={{ '& .MuiOutlinedInput-root': { borderRadius: '16px' } }} />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField fullWidth label="الجوال" name="mobile" value={form.mobile} onChange={handleChange} sx={{ '& .MuiOutlinedInput-root': { borderRadius: '16px' } }} />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField fullWidth label="الهاتف" name="phone" value={form.phone} onChange={handleChange} sx={{ '& .MuiOutlinedInput-root': { borderRadius: '16px' } }} />
            </Grid>
          </Grid>

          <FormControlLabel 
            control={<Switch name="isActive" checked={form.isActive} onChange={handleChange} />} 
            label="المورد نشط" 
          />

          <Box sx={{ display: 'flex', gap: 1.5, flexDirection: isModal ? { xs: 'column-reverse', sm: 'row' } : 'column' }}>
            {isModal && (
              <Button type="button" variant="outlined" color="inherit" onClick={handleCancel} disabled={loading} size="large" sx={{ flex: 1, borderRadius: '16px', py: 1.5 }}>
                إلغاء
              </Button>
            )}
            <Button type="submit" variant="contained" disabled={loading} size="large" sx={{ flex: 1, width: isModal ? 'auto' : '100%', borderRadius: '16px', py: 1.5, background: '#1e40af' }}>
              {loading ? <CircularProgress size={24} color="inherit" /> : "💾 حفظ البيانات"}
            </Button>
          </Box>
        </form>
      </Paper>

      {/* ✅ نافذة النجاح (Success Modal) - تظهر عند تفعيل successModal */}
      <Dialog open={successModal} PaperProps={{ sx: { borderRadius: '24px', p: 3, width: '350px', textAlign: 'center' } }}>
        <DialogContent>
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
            <Box sx={{ width: 80, height: 80, borderRadius: '50%', border: '2px solid #22c55e', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#22c55e" strokeWidth="3"><polyline points="20 6 9 17 4 12"></polyline></svg>
            </Box>
            <Typography variant="h6" fontWeight="bold">تمت العملية بنجاح</Typography>
          </Box>
        </DialogContent>
      </Dialog>
    </Container>
  );
}